import React from 'react';
import { CTAButtonWrapper } from "../../../../../landing-pages/js/common/styled-components/styled-components";
import Image from '../../../components/loggedout/common/Image';
import * as S from './style';
import { CTAPrimaryButton } from '../../../components/loggedout/shared-styles/CTAPrimaryButton';

import { Link } from 'react-router-dom';
import { codGrey } from '../../../components/loggedout/shared-styles/Colors';
// import Routes from '../../../../routes/routes';
import { featureList } from './data';
import ListItem from './list-item';
import ImacImage from './imac-section';
import AppleDownload from '~images/sem/apple-download.svg';
import GoogleDownload from '~images/sem/google-download.svg';
// import { PARENT_SIGNUP_PATH } from '../../../routes/route-paths';

const FeaturesList = ({btnClickEvent, ctaText, urlToRedirect }) => {
  let headingText = "Sign up now!"
  // let ctaText = 'Sign up for free';
  return (
    <S.ContainerWrapper noBackground={true}>
      <S.FeaturesWrapper>
        <S.HeadingText>{headingText}</S.HeadingText>
        <S.SubHeadingText>Plans start from $5 per month</S.SubHeadingText>
        <S.ListWrapper>
          {
            featureList.map((item, idx) =>
              <ListItem
                item={item}
                key={idx}
                fColor={codGrey}
                key={idx}
                bulletColor={'#69D5C1'}
              />
            )
          }
        </S.ListWrapper>
        <S.ButtonWrapper>
          <CTAButtonWrapper>
            <CTAPrimaryButton darkBlue={true}>
              <a href={urlToRedirect} onClick={btnClickEvent}>
                {ctaText}
              </a>
            </CTAPrimaryButton>
          </CTAButtonWrapper>
        </S.ButtonWrapper>

      </S.FeaturesWrapper>
      <S.ImageContainer>
        <S.ImacSectionWrapper>
          <ImacImage />
        </S.ImacSectionWrapper>
        <S.AppDownloads>
          <p>Also available on iOS and Android</p>
          <S.IconsContainer>
            <Image alt="image" src={AppleDownload} />
            <Image alt="image" src={GoogleDownload} />
          </S.IconsContainer>
        </S.AppDownloads>
      </S.ImageContainer>
    </S.ContainerWrapper>
  )
}

export default FeaturesList;